import smartMoneyApiService from '@/request/smartMoney/smartMoney.api.service';
import {} from '@/request/smartMoney/smartMoney.response.interface';
import { useAppStore } from '@/store';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useEffect, useState } from 'react';

interface IProfit {
  pnl: number;
  roi: number;
}

export const useAddressProfit = () => {
  const { walletAddress } = useBoomWallet();
  const { chainInfo } = useAppStore();
  const [profit, setProfit] = useState<IProfit>({ pnl: 0, roi: 0 });
  const chain: 'bsc' | 'sol' = chainInfo.chain == 'solana' ? 'sol' : 'bsc';
  const [timeRange, setTimeRange] = useState<'7d' | '30d'>('7d');

  const getAddressProfit = async () => {
    try {
      if (!walletAddress) return;
      const res = await smartMoneyApiService.getAddressDailyInfo({ chain, address: walletAddress, timeRange });
      if (res.lastActiveTime) {
        setProfit({
          pnl: res.totalRealizedPnL,
          roi: res.totalRealizedRoi,
        });
      }
    } catch (error: any) {
      throw error.message;
    }
  };

  useEffect(() => {
    getAddressProfit();
  }, [chain, timeRange, walletAddress]);

  return { profit, setTimeRange };
};
